module.exports = __webpack_public_path__ + "img/screenshot.dad95057.svg";